import {
  Box,
  Container,
  Wrap,
  Text,
} from '@chakra-ui/react';
import { useRef } from 'react';

import MainLayout from '@src/components/layouts/main';
import PrintablePdf from '@src/modules/performance/components/PrintablePdf';
import DataDisclaimer from '@src/modules/performance/components/DataDisclaimer';
import Pagination from '../../components/Pagination';
import DataQualityReportHeader from './components/report-headers/DataQualityReportHeader';
import DataQualityScore from './components/report-sections/DataQualityScore';
import DataQualityExpectedStandard from './components/report-sections/DataQualityExpectedStandard';

function DataQuality() {
  const printableRef = useRef();

  return (
    <MainLayout backgroundColor="gray.50">
      <Container maxW="full">
        <Pagination
          pdfPrint={(
            <PrintablePdf
              fileName="Data Quality"
              printableRef={printableRef}
              printableStyles={null}
            />
          )}
          moreInfo={(
            <>
              <Text mb={4}>Data Quality is critical to the New Zealand transport sector’s approach to developing and improving consistent levels of service, asset management and investment decision making.</Text>
              <Text mb={4}>The Road Efficiency Group (REG) established a Data Quality Framework in 2014/15 to measure and report the quality of roading asset data.</Text>
              <Text mb={4}>This page charts two indicators of data quality improvement by the network: the weighted annual score and the percentage that the data is at an acceptable standard.</Text>
            </>
          )}
        />
        <Box ref={printableRef}>
          <DataQualityReportHeader />
          <Wrap spacing={2} className="report-sections-wrapper">
            <DataQualityScore />
            <DataQualityExpectedStandard />
          </Wrap>
        </Box>
        <DataDisclaimer />
      </Container>
    </MainLayout>
  );
}

export default DataQuality;
